import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const stats = [{
  value: '+350%',
  label: 'Aumento en Llamadas'
}, {
  value: '47',
  label: 'Contratos Cerrados en 90 Días'
}, {
  value: '$2.3M',
  label: 'Generados para Clientes HVAC'
}];
const testimonials = [{
  quote: 'Antes recibíamos 2-3 llamadas por semana. Ahora no damos abasto con las solicitudes de instalación. Doctor Ecommerce cambió nuestro negocio por completo.',
  name: 'Carlos M.',
  company: 'AC Solutions Miami'
}, {
  quote: 'Dejé de tirar dinero en leads compartidos. Ahora cada dólar que invierto me regresa multiplicado. En 60 días duplicamos nuestros contratos.',
  name: 'Roberto G.',
  company: 'FreshAir HVAC Tampa'
}, {
  quote: 'El sistema de seguimiento automático es increíble. Clientes que antes se perdían ahora nos llaman de vuelta. Mejor inversión que he hecho.',
  name: 'María L.',
  company: 'CoolBreeze Services Orlando'
}];
export function TestimonialsSection() {
  return <section id="resultados" className="py-24 bg-[#0D0D0D] border-t border-white/5 relative" data-id="element-287">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-289">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-290">
            Resultados Reales para{' '}
            <span className="text-[#50C878] drop-shadow-[0_0_10px_rgba(80,200,120,0.4)]" data-id="element-291">
              Negocios HVAC
            </span>
          </motion.h2>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20 max-w-5xl mx-auto" data-id="element-292">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111111] border border-[#50C878]/30 rounded-2xl p-8 text-center shadow-[0_0_20px_rgba(80,200,120,0.1)] hover:shadow-[0_0_30px_rgba(80,200,120,0.2)] transition-shadow duration-300" data-id="element-293">
              <div className="text-4xl md:text-5xl font-extrabold text-[#FFD700] mb-2 drop-shadow-[0_0_8px_rgba(255,215,0,0.3)]" data-id="element-294">
                {stat.value}
              </div>
              <div className="text-[#C0C0C0] font-bold uppercase tracking-wider text-sm" data-id="element-295">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-296">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-gradient-to-b from-[#111111] to-[#0A0A0A] p-8 rounded-2xl border border-white/10 hover:border-[#50C878]/50 transition-colors duration-300 relative group" data-id="element-297">
              <div className="flex gap-1 mb-6" data-id="element-298">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700] drop-shadow-[0_0_5px_rgba(255,215,0,0.5)]" data-id="element-299" />)}
              </div>
              <blockquote className="text-[#C0C0C0] text-lg leading-relaxed mb-8 italic" data-id="element-300">
                "{testimonial.quote}"
              </blockquote>
              <div className="mt-auto" data-id="element-301">
                <div className="font-bold text-white text-lg" data-id="element-302">
                  {testimonial.name}
                </div>
                <div className="text-[#50C878] font-medium text-sm mt-1" data-id="element-303">
                  {testimonial.company}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}